<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="search"
                  placeholder="Key in payroll bank here"
                  append-icon="search"
                  label="Search Payroll Bank"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-spacer />
              <v-col cols="2">
                <payroll-setup-payroll-banks-dialog-create 
                  v-if="$hasPermissionTo(['create payroll banks'])"
                  @created="loadPayrollBanks"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          <v-data-table
            :headers="headers"
            :items="payrollBanks"
            :loading="tableLoading"
            :search="search"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </template>

            <template v-slot:item.shift_code="{ item }">
              <div>
                <span>
                  {{ item.shift_code ? item.shift_code : 'N/A' }}
                </span>
              </div>
            </template>
            <template v-slot:item.bank_code="{ item }">
              <div>
                <span>
                  {{ item.bank_code ? item.bank_code : 'N/A' }}
                </span>
              </div>
            </template>
            <template v-slot:item.is_template_ready="{ item }">
              <div>
                <span>
                  <v-icon medium>
                    {{ item.is_template_ready ? 'mdi mdi-check-circle text-success' : 'mdi mdi-close-circle text-danger' }}
                  </v-icon>
                </span>
              </div>
            </template>
          
            <template v-slot:item.action="{ item }">
              <span>
                <payroll-setup-payroll-banks-dialog-edit
                  v-if="$hasPermissionTo(['update payroll banks'])"
                  :payroll-bank="item"
                  @updated="loadPayrollBanks"
                />
    
              </span>
            </template>
          </v-data-table>
        </v-card> 
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  export default {
    components: {
      PayrollSetupPayrollBanksDialogCreate: () => import('@/components/payroll/setup/payroll-banks/DialogCreate'),
      PayrollSetupPayrollBanksDialogEdit: () => import('@/components/payroll/setup/payroll-banks/DialogEdit'),
    },

    data () {
      return {
        payrollBanks: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Shift Code',
            align: 'left',
            value: 'shift_code',
            sortable: false,
          },
          {
            text: 'Bank Code',
            align: 'left',
            value: 'bank_code',
            sortable: false,
          },
          {
            text: 'Is Template Ready',
            align: 'center',
            value: 'is_template_ready',
            sortable: false,
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        tableLoading: false,
      }
    },
    created () {
      this.loadPayrollBanks()
    },
    methods: {
      loadPayrollBanks () {
        this.tableLoading = true

        this.$api.payrollBanks().list()
          .then(res => {
            this.payrollBanks = _.orderBy(res.data, ['is_template_ready'], ['desc'])

            this.tableLoading = false
          })
      },
    },
  }
</script>
